module.exports = {
	"articleTitle1": "Henderson House, a co-op for the cooperative",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Henderson House",
	"articleLink1": "https://www.michigandaily.com/article/henderson-house-co-op-cooperative",
	"articleLink2": "http://www.michigandaily.com/content/smallest-univeristy-residence-hall-henderson-hidden-gem",
	"articleSnippet1": "Jan 10, 2012 ... The Henderson House is the only University-owned co-op in Ann Arbor. Founded \nin 1942, Henderson rests on the corner of Hill Street and ...",
	"articleSnippet2": "Jan 16, 2008 ... The smallest univeristy residence hall: Henderson, the hidden gem ... With \nenough space for just 25 female students, Henderson House isn't ...",
	"totalMisc": 0,
	"articleTitle2": "Henderson, the hidden gem",
	"address": "1330 Hill St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.271845,
		"lng": -83.731805
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/hendersonhouse.json
// module id = 890
// module chunks = 0